export default "__VITE_ASSET__BsP2Gkua__"